import { useQuery } from "@tanstack/react-query";
import type { QuestWithSteps } from "@/components/QuestCard";
import { env } from "@/utils/envs";
import QueryKey from "@/utils/queryKeys";

type ActiveQuestsResponse = {
	quests: QuestWithSteps[];
	appliedFilters?: Record<string, string>;
};

async function fetchActiveQuests(): Promise<QuestWithSteps[]> {
	const response = await fetch(
		`${env.VITE_SHINKAI_WEB_API_URL}/api/rewards/active-quests`,
	);
	if (!response.ok) {
		throw new Error("Failed to fetch quests");
	}
	const data = (await response.json()) as ActiveQuestsResponse;
	return data.quests ?? [];
}

/**
 * Fetches the public list of active quests from /api/rewards/active-quests.
 *
 * Shared across QuestsPage and HomePage so every consumer shares the same
 * cache entry and avoids duplicate network requests.
 */
export const useActiveQuests = () => {
	return useQuery({
		queryKey: [QueryKey.ACTIVE_QUESTS],
		queryFn: fetchActiveQuests,
		refetchOnWindowFocus: true,
	});
};
